export default __webpack_public_path__ + "static/media/fNeutral1.57fe1d8b.png";